document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper(".upsell-carousel", {
    grabCursor: true,
    slidesPerView: "2",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },  
      
  });  
});